import { useMailScope } from "./mailScope";
import { useQuery } from "@tanstack/react-query";
import { Alert, Collapse, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import { useApi, useMe } from "../../lib/useApi";
import { hasFeature } from "../../lib/features";
import { hasRole } from "../../lib/roles";

export function MailHelp() {
  const api = useApi();
  const scope = useMailScope();
  const me = useMe();
  const status = useQuery({ queryKey: ["dlp", "mail", scope, "status"], queryFn: api.mailStatus,
    enabled: hasFeature(me.data, "dlp.mail") && hasRole(me.data, "dlp:viewer"), retry: false, gcTime: 0, refetchInterval: 30_000 });
  const state = me.data?.license.state;
  return <Space direction="vertical" style={{ width: "100%", marginBottom: 16 }}>
    <Space wrap><Link to="/dlp/mail/my">自分のメール</Link><Link to="/dlp/mail/approvals">割当承認</Link>
      {hasRole(me.data, "dlp:approver") && <Link to="/dlp/mail/messages">管理・ドレイン</Link>}
      {hasFeature(me.data, "dlp.mail") && hasRole(me.data, "dlp:viewer") && <><Link to="/dlp/mail/rules">規則</Link><Link to="/dlp/mail/status">状態</Link><Link to="/dlp/mail/downloads">ダウンロード記録</Link></>}
      {hasFeature(me.data, "dlp.mail_inbound") && hasRole(me.data, "dlp:admin") && <Link to="/dlp/mail/inbound">受信の記録</Link>}
    </Space>
    {status.data?.mode === "bypass" && <Alert banner type="warning" message="bypass 中: メールは検査せず素通しにしています" />}
    {state === "expired" && <Alert banner type="warning" message="ライセンス失効: 判定と新しい保留は継続します。規則・設定は変更できません。既存分のドレイン操作は使えます" />}
    {(state === "missing" || state === "invalid" || !hasFeature(me.data, "dlp.mail")) && <Alert banner type="warning" message="メール機能を利用できません。新規は 451 で止め、既存分の閲覧・承認・却下・取消などのドレイン操作は使えます" />}
    {status.data && !status.data.gateway.alive && <Alert banner type="error" message="gateway の heartbeat が途絶しています。gateway を先に復旧してください" />}
    {hasFeature(me.data, "dlp.mail") && status.data?.files?.host_configured !== false && <Collapse size="small" items={[{ key: "files", label: "添付のダウンロードリンクについて", children: <ul style={{ margin: 0, paddingLeft: 20 }}>
      {!status.data && <li>リンク化が有効かどうかは管理者の設定によります。メール詳細に「リンク」の表示があれば、そのメールはリンク化されています</li>}
      <li>添付はダウンロードリンクに置き換えられ、社外の宛先は一定期間(既定 7 日。設定で 1〜30 日)、自分のアドレスで確認コードを受け取って取り出せます。個別の期限はメール詳細の「ダウンロードリンク」の「期限」で確認してください。社内の宛先には添付がそのまま届きます</li>
      <li>リンクは送信者本人が失効できます。失効するとそれ以降は新たに取り出せません</li>
      <li>宛先が複数のときは宛先ごとに別のリンクになります。回収は「全宛先分を失効」で行えます</li>
      <li>S/MIME のメールはリンク化できず、添付のまま承認に回ります</li>
      <li>宛先がメーリングリストのときは、そのリストのアドレスを入力した人だけが取り出せます</li>
    </ul> }]} />}
    <Typography.Text type="secondary">社内試験 OU 限定。Gmail のルーティングを通らない経路・社内宛て・ドライブのリンク・機密モードは対象外。PDF・画像は読まず、暗号化 ZIP は検査できないため既定で拒否(規則「暗号化 ZIP の添付」を無効にすると保留)。保留中は届かず、期限を過ぎると送出されません。X-Itmgmt-Dlp を自分で付けられる経路は素通りし得ます。災害時の保留分はできる限り残すが保証しません。</Typography.Text>
  </Space>;
}
